import styled from "styled-components";
import { devices, colors } from "../../../base/styled/variables.styled";
export const HeaderWrapper = styled.header.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 48px;
  background-color: ${({ $inverse }) => $inverse ? colors.brand700 : colors.neutral000};
  min-height: 72px;
  max-width: 1280px;
  margin: 0px auto;
  position: relative;
  z-index: 1000;

  // @media ${devices.desktop} {
  //   border-bottom: 2px solid ${colors.brand75};
  // }

  @media ${devices.tablets}, ${devices.mobile} {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: rgba(0, 94, 184, 0.2) 0px 1px 4px 0px;
    padding: 1rem;
    height: auto;
    flex-wrap: wrap;
    z-index: 1100;
  }
`;
export const MobileMenuWrapper = styled.div `
  display: none;

  @media ${devices.tablets}, ${devices.mobile} {
    display: block;
    width: auto;
    
    // Override MenuWrapper width if necessary via deep selector if styled-components allows, 
    // or just rely on the container width constraint.
    // Since MenuWrapper has width: 100%, it will fill this container.
    // We need this container to NOT be 100% of the Header.
  }
`;
export const LogoContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 32px;
  padding: 8px 5px;
  
  img {
    height: auto;
    width: 71px;
  }

  @media ${devices.tablets}, ${devices.mobile} {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
    width: auto;
    flex-grow: 0;
  }
`;
export const ActionsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex: 1;
  width: 100%;
  justify-content: flex-end;
  margin-left: 2rem;

  @media ${devices.tablets}, ${devices.mobile} {
    display: none;
  }
`;
export const MobileActionsContainer = styled.div `
  display: none;
  align-items: center;
  gap: 0.5rem;

  @media ${devices.tablets}, ${devices.mobile} {
    display: flex;
  }

  /* Hide user name and dropdown icon in mobile header */
  .ps-user-full-name,
  .dropdown-icon {
    display: none !important;
  }
  
  /* Reset button styles for avatar trigger in mobile header */
  button {
    padding: 4px;
    font-size: 20px !important;

    &:hover, &.active {
        background: transparent;
        outline: none;
    }
  }

  .ps-user-avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
    max-width: 32px;
  }
`;
export const MobileSearchOverlay = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isOpen'].includes(prop),
}) `
  display: none;
  box-sizing: border-box;

  @media ${devices.tablets}, ${devices.mobile} {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #fff;
    padding: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 2000;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    
    > div {
      width: 100%;
      
      > div {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;
export const MenuUserContainer = styled.div `
  padding: 16px 0;
  border-top: 1px solid #E3E9FF;
  margin-top: auto;
  width: 100%;
  box-sizing: border-box;
`;
export const SearchWrapper = styled.div `
  width: 100%;
  flex: 1;
  
  > div {
    max-width: 100%;
    width: 100%;
  }
`;
export const AccessibilityTrigger = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: ${({ $inverse }) => ($inverse ? "#fff" : colors.brand500)};
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;

  span {
    font-size: 14px;
  }
`;
export const UserTriggerContent = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }

  .username {
    font-weight: 500;
    color: ${({ $inverse }) => ($inverse ? "#fff" : "#333")};
    font-size: 14px;
  }
`;
export const UserIconWrapper = styled.button.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ $inverse }) => ($inverse ? "#fff" : colors.brand500)};
  border: none;
  cursor: pointer;
  padding: 0;

  // Override generic button styles in MobileActionsContainer
  && {
    padding: 0;
    background-color: ${({ $inverse }) => $inverse ? "#fff" : colors.brand500};
    
    &:hover {
      background-color: ${({ $inverse }) => $inverse ? colors.neutral100 : colors.brand600};
      opacity: 1;
    }
  }
`;
//# sourceMappingURL=Header.style.js.map